import { administrationService } from '@/services';

export const administrationModule = {
  namespaced: true,
  state: () => ({
    deleted:{
      data: null,
      status: null,
    },
    cancel:{
      data: null,
      status: null,
    }
  }),
  mutations: {
    deleteEntities(state, body){
      administrationService.deleteEntities(body)
      .then((res) => {
        state.deleted.data = res
        state.deleted.status = {
          deleted: true
        }
      })
      .catch((error) => {
        state.deleted.data = null
        state.deleted.status = {
          error
        };
      }); 
    },
    cancelEntities(state, body){
      administrationService.cancelEntities(body)
      .then((res) => {
        state.cancel.data = res
        state.cancel.status = {
          canceled: true
        }
      })
      .catch((error) => {
        state.cancel.data = null
        state.cancel.status = {
          error
        };
      }); 
    },
  }
}